import { useBreadcrumb } from "core/features/breadcrumbs";
import Container from "components/Container";
import HeaderTable from "components/Page/HeaderTable";
import { useState } from "react";
import PageHeader from "components/Page/PageHeader";
import NewTable from "components/NewTable";
import useItensRetornoBancarioColumns from "./useItensRetornoBancarioColumns";
import useItensRetornosBancarios from "features/retorno-bancario/hooks/useItensRetornosBancarios";
import { useParams } from "react-router-dom";

function ConciliacaoBancariaPages() {
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const params = useParams<{
    dataInicio: string;
    dataFim: string;
    id?: string;
  }>();

  const { isLoading, data } = useItensRetornosBancarios({
    search,
    page,
    dataFim: params.dataFim,
    dataInicio: params.dataInicio,
    retornoBancarioId: params.id,
  });

  const columns = useItensRetornoBancarioColumns();

  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Retorno Bancário", url: "/financeiro/retorno-bancario" },
    {
      name: "Itens Processados",
    },
  ]);

  return (
    <Container>
      <PageHeader title="Itens Processados" />

      <NewTable
        title={() => (
          <HeaderTable
            value={search}
            onSearch={(q?: string) => setSearch(q!)}
          />
        )}
        loading={isLoading}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => setPage(p),
        }}
      />
    </Container>
  );
}

export default ConciliacaoBancariaPages;
